import { PostImport } from '@/social/types';
import eventBus from '@/messaging/event-bus';
import api from '../../API';

export class PostImportCreated {
  static eventName = 'post_import.created';

  postImport: PostImport;

  constructor(postImport: PostImport) {
    this.postImport = postImport;
  }
}

export function create(
  socialAccountId: number,
  uploadedFileId?: number,
): Promise<PostImport> {
  const endpoint = `social-accounts/${socialAccountId}/post-imports`;
  return api
    .post(endpoint, { uploadedFileId })
    .then((response) => {
      const postImport = response.data;
      eventBus.$emit(PostImportCreated.eventName, new PostImportCreated(postImport));
      return postImport;
    });
}
